import {
  getString,
} from "@surya-digital/leo-ts-types";

export interface UserNameDTO {
  firstName: string;
  lastName: string;
}

export class UserName {
  readonly isUserNameUserName: boolean = true;

  readonly firstName: string;
  readonly lastName: string;

  static readonly constraints = {
    "firstName": {
      "minSize": 1,
      "maxSize": 200,
      
      
      
      "matches": "^[A-Za-z\s]*$",
    },
    "lastName": {
      "minSize": 1,
      "maxSize": 200,
      
      
      
      "matches": "^[A-Za-z\s]*$",
    }
  }

  constructor(
  firstName: string, 
  lastName: string
  ) {
    UserName.validateFirstName(firstName);
    this.firstName = firstName;
    UserName.validateLastName(lastName);
    this.lastName = lastName;
  }

  static fromDTO(dto: UserNameDTO): UserName {
    const firstName = getString(dto, "firstName", InvalidUserNameFirstNameError);
    const lastName = getString(dto, "lastName", InvalidUserNameLastNameError);
    return new UserName(
      firstName,
      lastName
    );
  }

  toDTO(): UserNameDTO {
    const dto: UserNameDTO = {
        firstName: this.firstName,
        lastName: this.lastName
    };
    return dto;
  }
  private static validateFirstName = (firstName: string): void => {
    if(firstName.length < 1) {
      throw new InvalidUserNameFirstNameMinSizeError(
        1,
        `Attribute firstName is too short. Size is ${firstName.length}. Min size is 1.`
      );
    }
    if(firstName.length > 200) {
      throw new InvalidUserNameFirstNameMaxSizeError(
        200,
        `Attribute firstName is too long. Size is ${firstName.length}. Max size is 200.`
      );
    }
      if(firstName.trim().length === 0) {
        throw new InvalidUserNameFirstNameNonEmptyError(
          `Attribute firstName cannot be an empty string.`
        );
      }
    if(firstName.match(/^[A-Za-z\s]*$/) === null) {
      throw new InvalidUserNameFirstNameMatchesError(
        "^[A-Za-z\s]*$",
        `Attribute firstName does not match with ^[A-Za-z\s]*$.`
      );
    }
  }
  private static validateLastName = (lastName: string): void => {
    if(lastName.length < 1) {
      throw new InvalidUserNameLastNameMinSizeError(
        1,
        `Attribute lastName is too short. Size is ${lastName.length}. Min size is 1.`
      );
    }
    if(lastName.length > 200) {
      throw new InvalidUserNameLastNameMaxSizeError(
        200,
        `Attribute lastName is too long. Size is ${lastName.length}. Max size is 200.`
      );
    }
      if(lastName.trim().length === 0) {
        throw new InvalidUserNameLastNameNonEmptyError(
          `Attribute lastName cannot be an empty string.`
        );
      }
    if(lastName.match(/^[A-Za-z\s]*$/) === null) {
      throw new InvalidUserNameLastNameMatchesError(
        "^[A-Za-z\s]*$",
        `Attribute lastName does not match with ^[A-Za-z\s]*$.`
      );
    }
  }
  
}

UserName.prototype.toString = function toString(): string {
  return `UserName(firstName='${this.firstName}',lastName='${this.lastName}')`;
};

export class InvalidUserNameError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidUserNameError";
  }
}
export class InvalidUserNameFirstNameError extends InvalidUserNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidUserNameFirstNameError";
  }
}

export class InvalidUserNameFirstNameMaxSizeError extends InvalidUserNameFirstNameError {
  readonly maxSize: number;
  constructor(maxSize: number, message?: string) {
    super(message);
    this.maxSize = maxSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidUserNameFirstNameMaxSizeError";
  }
}

export class InvalidUserNameFirstNameMinSizeError extends InvalidUserNameFirstNameError {
  readonly minSize: number;
  constructor(minSize: number, message?: string) {
    super(message);
    this.minSize = minSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidUserNameFirstNameMinSizeError";
  }
}

export class InvalidUserNameFirstNameMatchesError extends InvalidUserNameFirstNameError {
  readonly matches: string;
  constructor(matches: string, message?: string) {
    super(message);
    this.matches = matches;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidUserNameFirstNameMatchesError";
  }
}

export class InvalidUserNameFirstNameNonEmptyError extends InvalidUserNameFirstNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidUserNameFirstNameNonEmptyError";
  }
}

export class InvalidUserNameLastNameError extends InvalidUserNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidUserNameLastNameError";
  }
}

export class InvalidUserNameLastNameMaxSizeError extends InvalidUserNameLastNameError {
  readonly maxSize: number;
  constructor(maxSize: number, message?: string) {
    super(message);
    this.maxSize = maxSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidUserNameLastNameMaxSizeError";
  }
}

export class InvalidUserNameLastNameMinSizeError extends InvalidUserNameLastNameError {
  readonly minSize: number;
  constructor(minSize: number, message?: string) {
    super(message);
    this.minSize = minSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidUserNameLastNameMinSizeError";
  }
}

export class InvalidUserNameLastNameMatchesError extends InvalidUserNameLastNameError {
  readonly matches: string;
  constructor(matches: string, message?: string) {
    super(message);
    this.matches = matches;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidUserNameLastNameMatchesError";
  }
}

export class InvalidUserNameLastNameNonEmptyError extends InvalidUserNameLastNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidUserNameLastNameNonEmptyError";
  }
}
